import { atom } from 'recoil';

export const isInAppNameState = atom({
	key: 'isInAppNameState',
	default: null,
});
